<template>
  <div class="pages">
    <div class="loginDiv">
      <div
        style="background: #ffffff; padding-bottom: 0px; border-radius: 10px"
      >
        <div class="logoTitle">
          <img
            src="../../assets/img/2234.svg"
            alt
            class="logoLogin"
            ondragstart="return false;"
          />
        </div>

        <template v-if="!clickStatus">
          <div class="tabItem1 uploadBg" data-index="1" @click="goupLoad(1)">
            <span>我是云作品用户</span>
          </div>
          <div class="tabItem2 uploadBg" data-index="2" @click="goupLoad(2)">
            <span>我想用云作品</span>
          </div>
        </template>

        <template v-if="clickStatus">
          <template v-if="clickIndex == 1">
            <div v-if="1==1" class="qrCode">
              <img
                :src="qrcodeImg"
                alt
                ondragstart="return false;"
                class="qrCodeImg"
              />
              <!--  -->
              <div class="codeUpmask" @click="goUserHome" v-if="scanCodeSuc">
                <img
                  src="../../assets/img/loginRefresh.svg"
                  alt
                  ondragstart="return false;"
                />
              </div>
            </div>
            <div class="tipCopy">
              <p v-if="1==1" class="pOne">微信扫一扫登录</p>
              <p v-if="1==2" class="pOne-1">功能升级中，将于2024/10/13恢复服务，请移步微信电脑版打开云作品小程序上传图片。</p>
              <p class="pTwo"></p>
            </div>
          </template>

          <template v-if="clickIndex == 2">
            <div class="qrCode">
              <img
                src="../../assets/img/wechatXacode.jpg"
                alt
                ondragstart="return false;"
                class="qrCodeImg"
              />
              <!--  -->
              <div class="codeUpmask" @click="goUserHome" v-if="scanCodeSuc">
                <img
                  src="../../assets/img/loginRefresh.svg"
                  alt
                  ondragstart="return false;"
                />
              </div>
            </div>
            <div class="tipCopy">
              <p class="pOne">微信扫一扫创建</p>
              <p class="pTwo"></p>
            </div>
          </template>
        </template>
      </div>
      <div
        class="feedbackMask"
        v-if="false"
        :class="slideIntoStatus ? 'slideinto' : 'slideout'"
      >
        <div class="feedbackQrCode">
          <img :src="xcxqrcode" alt class="qrCodeXcx" />
          <div class="feedbackTitle">
            <p>微信扫码提交反馈</p>
          </div>
        </div>
      </div>
    </div>

    <div class="icp" @click="goICP" style="cursor:pointer;">
      <div class="icp1">Copyright ©️ 上海聚摄科技有限公司</div>
      <div class="icp2">沪ICP备19030813号</div>
    </div>


    <!-- tip -->
    <transition name="el-zoom-in-top">
      <div class="generalTip" v-show="tipShow">
        <p>{{ tipMessage }}</p>
      </div>
    </transition>
  </div>
</template>

<script></script>
<script>
import { wechatQrcode, xcxQrcode, pollingBind, identity } from "@/request/api";
import Axios from "axios";

export default {
  name: "login",
  data() {
    return {
      slideIntoStatus: false,
      qrcodeImg: "",
      countdown: 60,
      xcxqrcode: "",
      clickStatus: false,
      clickIndex: 0,
      scanCodeSuc: false,
      tipShow: false,
      tipMessage: "通用错误，Message:错误信息",
    };
  },
  mounted() {},
  methods: {
    goupLoad(event) {
      this.clickStatus = true;
      if (event == 1) {
        this.clickIndex = 1;
        this.getQrcode();
      }else{
         this.clickIndex = 2;
      }
    },

    getQrcode() {
      const params = {
        scene_type: 1,
      };
      wechatQrcode(params).then((res) => {
        console.log(res, "res");
        this.qrcodeImg = res.data.data.qrcode_url;
        clearInterval(this.timeStatus);
        this.pollingBind(res.data.data.qrcode_login_token);
      });

      const data = {
        path: "subPage/feedBack/feedBack",
        width: 280,
      };
      // 问题二维码
      xcxQrcode(data).then((res) => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        this.xcxqrcode = url;
      });
    },
    goUserHome() {
      location.reload();
    },
    goICP() {
      window.open(
      "https://beian.miit.gov.cn/"
      );
    },
    slideInto() {
      if (this.slideIntoStatus) {
        this.slideIntoStatus = false;
      } else {
        this.slideIntoStatus = true;
      }
    },

    /**
     * 用户扫描二维码
     */
    pollingBind(token) {
      let that = this;
      let params = {
        qrcode_type: 1,
        qrcode_login_token: token,
      };
      pollingBind(params).then((res) => {
        if (res.status == 200) {
          window.localStorage.setItem(
            "access_token",
            JSON.stringify(res.data.data.access_token)
          );
          identity().then((res) => {
            console.log(res, "getUserIdentityInfo");
            if (res.data.data.identity == 1) {
              that.$router.push({
                path: "/tab",
              });
              window.clearTimeout(that.setTime);
            } else {
              that.tipShow = true;
              that.tipMessage = "您还不是云作品客户";
              console.log("111111111", that.tipMessage);
              setTimeout(() => {
                that.tipShow = false;
              }, 1000);
              that.getQrcode();
            }
          });

          return;
        } else {
          if (that.countdown <= 0) {
            window.clearTimeout(that.setTime);
            that.scanCodeSuc = true;
          } else {
            that.setTime = window.setTimeout(function () {
              that.countdown = that.countdown - 1;
              console.log(that.countdown);
              that.pollingBind(token);
            }, 1000);
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.pages {
  width: 100vw;
  height: 100vh;
  background-image: url(../../assets/img/loginBack.jpg);
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .icp {
  position: absolute;
  width: 100%;
  height: 60px;
  bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  }

  .icp1 {
  line-height: 25px;
  font-size: 13px;
  // font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  }

  .icp2 {
  line-height: 25px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  }

  .loginDiv {
    width: 330px;
    height: 440px;
    margin-top: -60px;
    border-radius: 10px;
    background: #ffffff;
    text-align: center;
    box-shadow: 3px 3px 11px 0px rgba(182, 182, 182, 0.14);
    position: relative;
    z-index: 20;
    .logoTitle {
      margin: 40px auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .logoLogin {
        // width: 120px;
        height: 35px;
        display: inline-block;
        vertical-align: middle;
      }

      .shuxian {
        font-size: 16px;
        margin: 0px 10px;
      }

      .titleType {
        font-size: 18px;
      }
    }

    .qrCode {
      width: 202px;
      height: 202px;
      display: block;
      margin: 50px auto 0;
      position: relative;
      .codeUpmask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .qrCodeImg {
        width: 202px;
        height: 202px;
      }
    }
    .pOne {
      color: rgba(0, 0, 0, 1);
      font-size: 15px;
      margin-top: 32px;
    }

    .pOne-1 {
      color: rgba(0, 0, 0, 1);
      font-size: 18px;
      margin: 80px 30px 0 30px;
      text-align: left;
    }

    .pTwo {
      font-size: 12px;
      margin-top: 8px;
    }
    .problem {
      font-size: 14px;
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .feedback {
        margin-right: 6px;
      }
    }
    .feedbackMask {
      position: absolute;
      left: 0;
      bottom: -12px;
      width: 100%;
      height: 132px;
      background: #f4f4f4;
      // background: #fff;
      z-index: -1;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .feedbackQrCode {
        // padding: 36px 0 0px;
        display: flex;
        justify-content: center;
        .qrCodeXcx {
          width: 70px;
          height: 70px;
        }
        .feedbackTitle {
          margin-left: 14px;
          text-align: left;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 16px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .noteP {
            font-size: 12px;
            font-weight: 400;
          }
        }
      }
    }
  }
}

.slideinto {
  transform: translate3d(0, 110px, 0);
  transition: transform 0.2s linear;
}

.slideout {
  transform: translate3d(0, 0, 0);
  transition: transform 0.2s linear;
}

.generalTip {
  position: fixed;
  top: 12px;
  left: 50%;
  background: #ec4d3d;
  color: #ffffff;
  padding: 10px;
  text-align: center;
  border-radius: 20px;
  width: 280px;
  margin-left: -160px;
  z-index: 1009;
}

.tabItem1 {
  width: 286px;
  height: 96px;
  margin: 60px auto 0px;
  line-height: 96px;
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 30px;
    height: 26px;
  }
  img {
    margin-right: 10px;
  }
  span {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    margin-top: 0px !important;
  }
}


.tabItem2 {
  width: 286px;
  height: 96px;
  margin: 20px auto 0px;
  line-height: 96px;
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 30px;
    height: 26px;
  }
  img {
    margin-right: 10px;
  }
  span {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    margin-top: 0px !important;
  }
}



.uploadBg {
  // background: url(../../assets/img/uploadBg.svg);
  // background-size: cover;
  background: rgba(0, 0, 0, 0.05)
}

.uploadBg:hover {
  background: rgba(0, 0, 0, 0.1)
}
</style>